import React, { Component } from "react";

class SearchMobile extends Component {
    constructor(props) {
        super(props);

        this.state = {}
    }

    render() {
        return (
            <div class="mob-search">
                <span class="search-close">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round" class="feather feather-chevron-left">
                        <polyline points="15 18 9 12 15 6"></polyline>
                    </svg>
                </span>
                <input type="search" class="input-search " placeholder="Search" />
            </div>
        )
    }
}

export default SearchMobile;